import React from 'react';
import PropTypes from 'prop-types';
import { getTableHeader, getTableBody } from './boxscoreTeamTable/utils/generateTeamTableData';
import CustomPlayerCell from './boxscoreTeamTable/CustomPlayerCell';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
import { dictKeys } from './boxscoreTeamTable/config/columns';
import BoxscoreTypes from './boxscoreTeamTable/config//BoxscoreTypes';
import {
    TeamTable,
    TeamTableWrapper
} from './BoxscoreTeamTable.style';
const { BATTERS, PITCHERS, BENCH, BULLPEN } = BoxscoreTypes;

const customCells = [
    {
        cellType: 'body',
        customCell: <CustomPlayerCell external={false} />,
        dataField: 'label'
    }
];

const BoxscoreTeamTable = ({
    lineups = [],
    language,
    type,
    isInProgress,
    team = '',
    teamStats = {},
    className,
    headerType
}) => {
    const translate = useTranslate();
    const totalsLabel = translate('box_totals', 'Totals');
    const thead = getTableHeader({
        type
    });
    const translatedThead = thead.map((cfg) => {
        const { content } = cfg;
        const isHeader = content === BATTERS || content === PITCHERS || content === BENCH || content === BULLPEN;
        const type = `${translate(dictKeys[content], content)}`;
        const teamText = isHeader ? ` - ${team} ` : '';
        return { ...cfg, content: `${type}${teamText}` };
    });

    const { rows, highlightedCells, currentBatterIndex } = getTableBody({
        language,
        players: lineups,
        type,
        isInProgress,
        teamStats,
        totalsLabel
    });
    const tbody = rows;
    return (
        <TeamTableWrapper className={ className }>
            <TeamTable
                headThPadding={'6px'}
                bodyThPadding={'2px 6px'}
                customCells={ customCells }
                thead={ translatedThead }
                tbody={ tbody }
                highlightedCells={ highlightedCells }
                bodyTdPadding={'6px'}
                className={ headerType }
                selectedRowIndex={currentBatterIndex}
            />
        </TeamTableWrapper>
    );
};

BoxscoreTeamTable.propTypes = {
    lineups: PropTypes.array,
    language: PropTypes.string,
    type: PropTypes.string,
    isInProgress: PropTypes.bool,
    team: PropTypes.string,
    teamStats: PropTypes.object,
    className: PropTypes.string,
    headerType: PropTypes.string
};

export default BoxscoreTeamTable;
